var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imofalform2FormHeader puiformheader"})
}
var staticRenderFns = []

export { render, staticRenderFns }